import { Heading } from "components/Heading";
import { useTranslation } from "react-i18next";
import { CreateClientForm } from "./CreateClientForm";
import { Suspense } from "react";
import { FormSectionPlaceholder } from "components/FormSectionPlaceholder";
import { ContentWrapper } from "components/ContentWrapper";
import { HeadingWrapper } from "components/HeadingWrapper";
import { Breadcrumbs } from "components/Breadcrumbs";

export const Container = () => {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumbs
        pages={[
          {
            name: t("Clients"),
            href: "/clients",
          },
          {
            name: t("New client"),
            href: "/clients/create",
            current: true,
          },
        ]}
      />
      <ContentWrapper>
        <HeadingWrapper>
          <Heading>{t("Create New Client")}</Heading>
        </HeadingWrapper>
        <Suspense fallback={<FormSectionPlaceholder />}>
          <CreateClientForm />
        </Suspense>
      </ContentWrapper>
    </>
  );
};
